
import { computed, defineComponent, nextTick } from 'vue'
import Dynamic from './index.vue'
import { getRequestLanguage } from '@/api/utils'
import { useI18n } from 'vue-i18n'
import { setAndroidBridgeTitle } from '@/utils/bridge'
import { setAppLaunchLoading } from '@/utils/domUtils'

export default defineComponent({
  name: 'DynamicApp',
  components: {
    Dynamic
  },
  setup() {
    const language = computed(() => {
      return getRequestLanguage()
    })

    nextTick(() => {
      const feedbackElement = document.getElementById('dynamic')
      if (feedbackElement) {
        if (language.value === 'ar') {
          feedbackElement.classList.add('rtl')
        }
      }
    })

    setTimeout(() => {
      setAppLaunchLoading('dynamic-loader')
    }, 500)

    const { t } = useI18n()
    setAndroidBridgeTitle(t('dynamic.title'))
  }
})
